// AppDataContext.js
import { createContext, useContext, useEffect, useState } from "react";
import { BindAPI } from "../services/APIConnection";

const AppDataContext = createContext();

export const AppDataProvider = ({ children }) => {
  const [itemsPerPages, setItemsPerPage] = useState(10);
  const [bindDDValues, setBindDDValues] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const [systemSettingsRes, ddValuesRes] = await Promise.all([
          BindAPI("SystemSettingsAPI/BindSystemSettings"),
          BindAPI("MasterDataAPI/BindDDValues"),
        ]);

        // ✅ Handle system settings
        if (systemSettingsRes?.data?.Table?.length > 0) {
          const rowsPerPageFromApi =
            systemSettingsRes.data.Table[0].RowsPerPageForTables;
          setItemsPerPage(rowsPerPageFromApi);
        }

        // ✅ Handle dropdown values
        const resultdata = ddValuesRes?.data?.Table || [];
        if (resultdata.length > 0) {
          const religionDD = resultdata.map((m) => ({
            value: m.NoOfRecords,
            label: m.NoOfRecords,
          }));
          setBindDDValues(religionDD);
        } else {
          setBindDDValues([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData(); // runs once on app load
  }, []);

  return (
    <AppDataContext.Provider value={{ itemsPerPages, bindDDValues, loading }}>
      {children}
    </AppDataContext.Provider>
  );
};

export const useAppData = () => useContext(AppDataContext);
